import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import Breadcrumb from '@/components/base/Breadcrumb';
import BrandIntro from './components/BrandIntro';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import BusinessCooperation from './components/BusinessCooperation';

const aboutJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '关于51暗网 - 专业吃瓜黑料追踪平台',
    description: '了解51暗网品牌故事、用户口碑和联系方式。专业的吃瓜黑料实时追踪平台。',
    url: 'http://chigualiao.cn/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '51暗网',
      url: 'http://chigualiao.cn/',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51暗网的内容来源可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51暗网的内容来自多位圈内资深爆料人和一线娱乐记者的供稿，我们拥有严格的内容审核机制，所有爆料均经过交叉验证后才会发布，确保信息的真实性和可靠性。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在51暗网上找到最新的爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以访问51暗网首页查看"最新追踪"板块，或者通过分类页面浏览您感兴趣的爆料类型。我们每天保持高频更新，确保您不错过任何热点。',
        },
      },
      {
        '@type': 'Question',
        name: '51暗网App在哪里下载？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51暗网App目前可通过官方网站的下载入口获取。我们提供iOS和Android两个版本，下载安装后即可随时随地追踪最新吃瓜黑料。请认准官方渠道下载，谨防假冒。',
        },
      },
      {
        '@type': 'Question',
        name: '可以向51暗网投稿爆料吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '当然可以！51暗网欢迎来自各方的真实爆料投稿。您可以通过网站底部的联系方式或关于我们页面的投稿通道提交您的爆料内容。我们会对投稿严格保密，并在核实后发布。',
        },
      },
      {
        '@type': 'Question',
        name: '51暗网的内容多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51暗网保持每日多次更新的频率。我们的编辑团队全天候关注热点事件，确保在第一时间为您带来最新、最热的吃瓜黑料内容。重大爆料事件我们会进行实时追踪报道。',
        },
      },
    ],
  },
];

export default function About() {
  return (
    <>
      <PageMeta
        title="关于51暗网 | 品牌介绍与商务合作 - 专业吃瓜黑料追踪平台"
        description="了解51暗网品牌故事、用户口碑、商务合作机会与联系方式。专业的吃瓜黑料实时追踪平台，每日更新网红塌房、明星黑料、娱乐圈爆料。"
        keywords="51暗网,关于51暗网,吃瓜平台,爆料平台,商务合作,联系方式,51暗网app下载"
        canonicalUrl="http://chigualiao.cn/about"
        jsonLd={aboutJsonLd}
      />
      <Navbar />
      <main className="pt-16">
        <div className="w-full px-4 md:px-6 bg-background-100 border-b border-background-200/70">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>
        <BrandIntro />
        <BusinessCooperation />
        <Testimonials />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}